import { employeeRequests } from "api/employeeApi";
import { administrationRequests } from "api/administrationApi";
import React from "react";
import { AutocompleteInput, Filter, ReferenceInput, SelectInput } from "react-admin";
import { getProfessorRecordText } from "server/components/Fields/_fieldsHelper";
import { CourseChoices, WeekDaysChoices } from "utils/choices";

const WeeklyScheduleDisciplinesFilters = props => {
  return (
    <Filter {...props}>
      <ReferenceInput
        source="roomId"
        reference={administrationRequests.getRoomsSelect()}
        alwaysOn
      >
        <AutocompleteInput
          label="Зала"
          optionValue="id"
          optionText={rec =>
            `${rec.roomName} (Номер на зала: ${rec.roomNumber || ""}) ${rec.buildingName} (Капацитет занятия: ${
              rec.capacityClasses || ""
            })`
          }
          filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          sx={{ width: "300px" }}
        />
      </ReferenceInput>

      <ReferenceInput
        source="disciplineId"
        reference={administrationRequests.getDisciplinesSelect()}
        alwaysOn
        filter={{ filterByUser: true }}
      >
        <AutocompleteInput
          optionValue="id"
          optionText="name"
          label="Дисциплина"
          filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          sx={{ width: "300px" }}
        />
      </ReferenceInput>
      <ReferenceInput
        source="professorEmployeeId"
        reference={employeeRequests.getProfessorsSelect()}
        fullWidth
        alwaysOn
        filter={{ filterByUser: true }}
      >
        <AutocompleteInput
          label="Преподавател"
          optionValue="id"
          optionText={getProfessorRecordText}
          filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          sx={{ width: "300px" }}
        />
      </ReferenceInput>
      <SelectInput
        source="course"
        label="Курс"
        choices={CourseChoices}
        optionValue="id"
        optionText="name"
        alwaysOn
        emptyText={"Всички"}
      />

      <SelectInput
        source="weekDay"
        label="Ден"
        choices={WeekDaysChoices}
        optionValue="id"
        optionText="name"
        alwaysOn
        emptyText={"Всички"}
      />
    </Filter>
  );
};

export default WeeklyScheduleDisciplinesFilters;
